import { absoluteUrl, SITE_URL } from './siteConfig';

/**
 * Schema.org JSON-LD for the public home page.
 * Every value below matches content that is visibly present on the site.
 */
export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '武汉俊鑫岚科技有限公司',
    url: SITE_URL ? absoluteUrl('/') : undefined,
    telephone: '13827693511',
    email: 'xiaomi5033vip@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressRegion: '湖北省',
      addressLocality: '武汉市',
      streetAddress: '武昌区中南路街中南路14号世纪广场B座16层A室-2',
      addressCountry: 'CN',
    },
    description:
      '专注建筑建材、机械电气、金属材料、电子配件、五金耗材等物资供应，为企业与工程客户提供一站式采购、配送与商务代理服务。',
  };
}

export function buildWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '武汉俊鑫岚科技有限公司',
    url: SITE_URL ? absoluteUrl('/') : undefined,
    inLanguage: 'zh-CN',
  };
}

export function buildHomeStructuredData() {
  return [buildOrganizationSchema(), buildWebsiteSchema()];
}